module.exports = __webpack_public_path__ + "static/media/conffeti-bottom.4dca03dc.png";